import { callDecimal } from "../utils.ts";
import { CompositeAsset } from "../common-types/manageAssets.ts";

export interface StoreData {
  bookFormat: string;
  coachMe: boolean;
  copyrightYear: number;
  distributable: boolean;
  freebie: boolean;
  hasMultipleFormats: boolean;
  imprintName: string;
  isSubscription: boolean;
  priceRange: string;
  priceStartingAt: string;
  slug: string;
}

export async function searchStore(query: string, size: number, offset: number) {
  const queryParams = new URLSearchParams();
  queryParams.set("q", query);
  queryParams.set("page[size]", size.toString());
  queryParams.set("page[offset]", offset.toString());
  return callDecimal<CompositeAsset<"store" | "favorite">[]>(
    `/api/v1/products/search?${queryParams.toString()}`
  );
}
